// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { DebtModel } from 'shared';

export interface DebtListStateModel {
  debtList: PaginatorModel<DebtModel> & { debtsAmount: number };
  loadDebtListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  scrollPosition: number;
}

export const DEBT_LIST_STATE_DEFAULT: DebtListStateModel = {
  debtList: {
    debtsAmount: 0,
    data: [],
    links: null,
    meta: null
  },
  loadDebtListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  scrollPosition: 0
};
